import Vue from 'vue'

export const eventBusUtility = new Vue({
	data() {
		return {
			comparators: {
				eq: (a, b) => a === b,
				gt: (a, b) => a > b,
				date_gt_today: (a, b) => moment().isBefore(a, 'day')
			},
			bg_colors: [
				'amber lighten-1',
				'orange lighten-1',
				'deep-orange lighten-1',
				'red lighten-1',
				'purple lighten-3',
				'deep-purple lighten-3',
				'indigo lighten-4',
				'blue lighten-4',
				'teal lighten-3'
			]
		}
	},

	methods: {
		// Calc background color of avatars
		bgColor(id) {
			return this.bg_colors[id % this.bg_colors.length]
		},

		dialogTitle(info) {
			if (info.labels) {
				return info.labels.modelTitle
			} else return ''
		},

		priorityColor(priority, type = '') {
			if (type === 'text') {
				type = '--text'
			} else {
				type = ' priority'
			}
			switch (priority) {
			case 'a':
				return 'red' + type
			case 'b':
				return 'amber' + type
			case 'c':
				return 'green' + type
			case 'd':
				return 'blue' + type
			}
		},

		movementColor(type) {
			switch (type) {
			case 'load':
				return 'green--text'
			case 'unload':
				return 'red--text'
			}
		},

		fidelitycardColor(type) {
			switch (type) {
			case 'hairdresser':
				return 'blue--text'
			case 'beautycenter':
				return 'cyan--text'
			}
		},

		// Set varible selected in Quill Editor
		setVaribleTexEditor(QuillEditor, variable) {
			let range = QuillEditor.getSelection(true)
			if (range.length == 0) {
				QuillEditor.insertText(range.index, '{{' + variable + '}}')
			} else if (range.length > 0) {
				QuillEditor.deleteText(range.index, range.length)
				QuillEditor.insertText(range.index, '{{' + variable + '}}')
			}
		},

		// ROUTER UTILITIES
		chooseRedirect(router, response, redirect, modelDef) {
			// IF BACK TURN BACK
			if (_.hasIn(redirect, 'back')) {
				router.go(redirect.back)
			} else {
				// TURN BACK IN MODEL SPECIFIED AND EREDITED BY CRUD
				if (redirect && _.hasIn(redirect, 'modelDef')) {
					router.push({
						name: redirect.modelDef,
						params: { id: parseInt(redirect.id) }
					})
				} else {
					// IF IN CREATE
					if (response.data.id) {
						router.push({
							name: modelDef,
							params: { id: parseInt(response.data.id) }
						})
					}
					// ELSE IN EDIT AND TURN IN SHOW
					else {
						router.push({ name: modelDef })
					}
				}
			}
		},

		goTo(router, name, id) {
			if (id) {
				router.push({ name: name, params: { id: parseInt(id) } })
			} else {
				//router.push({ name: name })
			}
		},

		openFile(store, url, filename) {
			fetch(store.getters.baseUrl + '/api' + url, {
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
					Authorization: 'Bearer ' + store.getters.token
				}
			}).then(r => {
				r.blob().then(blob => this.showFile(blob, filename))
			})
		},

		showFile(blob, filename) {
			// otherwise only Chrome works like it should
			// It is necessary to create a new blob object with mime-type explicitly set
			let newBlob = new Blob([blob], { type: blob.type })

			// IE doesn't allow using a blob object directly as link href
			// instead it is necessary to use msSaveOrOpenBlob
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob)
				return
			}

			// For other browsers:
			// Create a link pointing to the ObjectURL containing the blob.
			const data = window.URL.createObjectURL(newBlob)
			let link = document.createElement('a')
			link.href = data
			link.setAttribute('target', '_blank')
			link.download = filename
			link.click()
			setTimeout(function() {
				// For Firefox it is necessary to delay revoking the ObjectURL
				window.URL.revokeObjectURL(data), 100
			})
		},

		changeNotificationStatus(notifications, status) {
			let notification_ids = []
			_.forEach(notifications, value => {
				notification_ids.push(value.id)
			})
			this.axios
				.put('notifications/', {
					status: status,
					notifications: notification_ids
				})
				.then(response => {
					// get body data
					_.forEach(notifications, notification => {
						if (status === 'read') {
							notification.read_at = new Date()
						} else if (status === 'unread') {
							notification.read_at = null
						}
					})
					this.$eventBusUtility.$emit('updateNotifications', true)
					this.$eventBusUtility.$emit('updateNotificationsCheckbox', true)
				},
				response => {
					// error callback
				})
		},

		exportCSV(theaders, selected, title) {
			let csv = []
			let headers = []
			let row = []
			// Take headers
			_.forEach(theaders, header => {
				headers.push(header.text)
			})
			// Write first row of headers
			csv.push(headers.join(';'))
			// Take all tr -> forEach tr take cell -> forEach cell check if is checked
			let rows = _.each(selected, obj => {
				row = []
				_.forEach(theaders, header => {
					row.push(obj[header.text_value ? header.text_value : header.value])
				})
				csv.push(row.join(';'))
			})
			this.downloadCSV(csv.join('\n'), title)
		},

		downloadCSV(csv, filename) {
			let csvFile
			let downloadLink

			// CSV file
			csvFile = new Blob([csv], { type: 'text/csv' })
			// Download link
			downloadLink = document.createElement('a')
			// File name
			downloadLink.download = filename + '.csv'
			// Create a link to the file
			downloadLink.href = window.URL.createObjectURL(csvFile)
			// Hide download link
			downloadLink.style.display = 'none'
			// Add the link to DOM
			document.body.appendChild(downloadLink)
			// Click download link
			downloadLink.click()
		},

		fieldsGeneratorConditions(field, event, fieldsset, model) {
			let targets = field.targets
			if (typeof event === 'undefined') {
				Vue.set(model, field.key, null) // set null instead of undefined
			}
			if (typeof targets === 'undefined') return
			Vue.nextTick(() => {
				_.forEach(targets, target => {
					fieldsset.fields.filter(f => {
						if (f.key === target.key) {
							if (target.type == 'cascade') {
								// If delete primary select the second select must be empty
								if (!model[field.key]) {
									Vue.set(f, 'options', [])
									Vue.set(model, f.key, null)
								} else {
									let split = []
									let urlForOptions = ''
									if (f.parent_type === 'morphTo') {
										// split projects_2 construct project/2/tasklists
										split = _.split(model[field.key], '_', 2)
										urlForOptions =                      split[0] + '/' + split[1] + '/' + target.url
									} else if (f.parent_type === 'belongsTo') {
										// companycategory/3/subcompanycategories
										urlForOptions =                      target.url_model +                      '/' +                      model[field.key] +                      '/' +                      target.url
									}
									this.axios.get(urlForOptions).then(response => {
										// Set select options in child select
										Vue.set(f, 'options', response.data)
										model[f.key] = null
									},
									response => {})
								}
							} else if (target.type == 'change_other') {
								if (!model[field.key]) {
									/*Vue.set(f, 'options', [])
								model[f.key] = target.empty_value*/
								} else {
									let result = false

									_.forEach(target.conditions, condition_or => {
										let and_result = true
										_.forEach(condition_or, condition_and => {
											let condition_value
											if (typeof condition_and.field !== 'undefined') {
												condition_value = model[condition_and.field]
											} else {
												field.options.filter(option => {
													if (option.value === model[field.key]) {
														condition_value = option[condition_and.key]
													}
												})
											}
											if (
												!this.comparators[condition_and.compare](condition_value,
													condition_and.value)
											) {
												and_result = false
												return false
											}
										})

										if (!result && and_result) {
											result = true
											return false
										}
									})
									if (result) {
										if (typeof target.real_key !== 'undefined') {
											Vue.set(model, target.real_key, target.set)
										} else {
											Vue.set(model, f.key, target.set)
										}
									}
								}
							}
						}
					})
				})
			})
		},

		formatAddress(model, suffix = '') {
			if (model) {
				let address = ''
				suffix = suffix == '' ? suffix : suffix + '_'
				if (model[suffix + 'address_street']) {
					address += model[suffix + 'address_street']
				}
				if (model[suffix + 'address_number']) {
					if (model[suffix + 'address_street']) {
						address += ', '
					}
					address += model[suffix + 'address_number']
				} else {
					//address += ','
				}
				if (model[suffix + 'address_zipcode']) {
					address += ' ' + model[suffix + 'address_zipcode']
				}
				if (model[suffix + 'address_city']) {
					address += ' ' + model[suffix + 'address_city']
				}
				if (model[suffix + 'address_province']) {
					address += ' ' + model[suffix + 'address_province']
				}

				return address
			}
		},

		formatDate(date) {
			if (!date) return null

			const [year, month, day] = date.split('-')
			return `${day}/${month}/${year}`
		}
	}
})
